// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Storm-module__container___HzBcX {
    position: relative;
    display: inline-block;
    height: 510px;
    width: auto;
    aspect-ratio: 874/510;

    transform: perspective(2000px);
    transition: all 0.3s ease;
    /* Add depth to the whole panel */
    box-shadow: 
        -20px 20px 30px rgba(0, 0, 0, 0.2),
        -5px 5px 15px rgba(0, 0, 0, 0.1),
        inset 2px -2px 5px rgba(255, 255, 255, 0.2);
}

.Storm-module__backgroundImage___e6XoH {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;

    background: linear-gradient(
        105deg,
        rgba(255, 255, 255, 0.2) 0%,
        rgba(255, 255, 255, 0) 40%
    );
}


.Storm-module__overlayImage___vVmbD, .Storm-module__overlayVideo___NYYAI {
    position: absolute;
    top: 0.3%;
    left: 3%;
    width: 94%;
    height: 99%;
    object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Panels/Storm/Storm.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,WAAW;IACX,qBAAqB;;IAErB,8BAA8B;IAC9B,yBAAyB;IACzB,iCAAiC;IACjC;;;mDAG+C;AACnD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB;;;;KAIC;AACL;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB","sourcesContent":[".container {\n    position: relative;\n    display: inline-block;\n    height: 510px;\n    width: auto;\n    aspect-ratio: 874/510;\n\n    transform: perspective(2000px);\n    transition: all 0.3s ease;\n    /* Add depth to the whole panel */\n    box-shadow: \n        -20px 20px 30px rgba(0, 0, 0, 0.2),\n        -5px 5px 15px rgba(0, 0, 0, 0.1),\n        inset 2px -2px 5px rgba(255, 255, 255, 0.2);\n}\n\n.backgroundImage {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n\n    background: linear-gradient(\n        105deg,\n        rgba(255, 255, 255, 0.2) 0%,\n        rgba(255, 255, 255, 0) 40%\n    );\n}\n\n\n.overlayImage, .overlayVideo {\n    position: absolute;\n    top: 0.3%;\n    left: 3%;\n    width: 94%;\n    height: 99%;\n    object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Storm-module__container___HzBcX`,
	"backgroundImage": `Storm-module__backgroundImage___e6XoH`,
	"overlayImage": `Storm-module__overlayImage___vVmbD`,
	"overlayVideo": `Storm-module__overlayVideo___NYYAI`
};
export default ___CSS_LOADER_EXPORT___;
